import React from 'react';
import PropTypes from 'prop-types';

import LinkWithSourcePath from 'utils/LinkWithSourcePath';
import { oCurrencyFormatter } from 'utils/common';
import InfoButtonWithModal from 'components/Layout/InfoButtonWithModal';
import { fnBuildTotalDistributionsInfo } from './helpers';

const FundOverview = ({
  aContacts,
  sLatestValue,
  sTotalDistributions,
  aFinancialData = [],
  sFundName = '',
}) => {
  const fTotalDistributions = Math.abs(parseFloat(sTotalDistributions));
  const infoModalContent = fnBuildTotalDistributionsInfo(
    aFinancialData,
    sFundName
  );

  return (
    <div className='philanthropyReport__fundOverview philanthropyReport__overviewContainer'>
      <h4 className='philanthropyReport__fundOverviewTitle t-label'>
        Fund Overview
      </h4>
      {sLatestValue && (
        <p className='fundOverview__stat'>
          Latest Value:{' '}
          <span className='fundOverview__statValue'>
            {oCurrencyFormatter.format(sLatestValue)}
          </span>
        </p>
      )}
      {sTotalDistributions && parseFloat(sTotalDistributions) !== 0 && (
        <p className='fundOverview__stat'>
          Total Distributions:{' '}
          <span className='fundOverview__statValue'>
            {oCurrencyFormatter.format(fTotalDistributions)}
          </span>
          {infoModalContent && (
            <InfoButtonWithModal
              modalText={infoModalContent}
              buttonClassName='fundOverview__infoButton'
            />
          )}
        </p>
      )}
      {aContacts.length > 0 && (
        <ul className='philanthropyReport__fundContactList'>
          {aContacts.map((oContact) => (
            <li
              className='philanthropyReport__fundContact t-paragraph--medium'
              key={oContact.LOOKUPID}
            >
              <span>Contact for Assistance:</span>
              <LinkWithSourcePath
                to={`/philanthropy/profile/${oContact.LOOKUPID}`}
                referringComponent='PhilanthropyReport'
                className='philanthropyReport__fundContactLink'
              >
                {oContact.NAME}
              </LinkWithSourcePath>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

FundOverview.propTypes = {
  aContacts: PropTypes.arrayOf(
    PropTypes.shape({
      LOOKUPID: PropTypes.string,
      NAME: PropTypes.string,
    })
  ),
  sLatestValue: PropTypes.string,
  sTotalDistributions: PropTypes.string,
  aFinancialData: PropTypes.arrayOf(PropTypes.shape({})),
  sFundName: PropTypes.string,
};

FundOverview.defaultProps = {
  aContacts: [],
  sLatestValue: '',
  sTotalDistributions: '',
  aFinancialData: [],
  sFundName: '',
};

export default FundOverview;
